export default __webpack_public_path__ + "static/media/success-square.69374244.svg";